// GetWalletPage returns data for rendering coupon & coins wallet page
export const WalletService_GetWalletLazy = () =>
  import("./service.grpc").then((m) => m.WalletService_GetWallet);
WalletService_GetWalletLazy.method =
  "aysa_api.services.wallet.v1.page.WalletService/GetWallet" as const;

// ClaimBonusLevel allows to claim the latest bonus level in Coins Wallet
export const WalletService_ClaimBonusLevelLazy = () =>
  import("./service.grpc").then((m) => m.WalletService_ClaimBonusLevel);
WalletService_ClaimBonusLevelLazy.method =
  "aysa_api.services.wallet.v1.page.WalletService/ClaimBonusLevel" as const;
